import React from 'react';
import Button from '@nubank/nuds-web/components/Button/Button';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { generateBranchLink } from '../../../../../../../../utils/branchIO/generateBranchLink';
import { useRegistrationFormContext } from '../../../../../RegistrationForm/RegistrationForm';

const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
`;

const MagicLinkBtn = ({ label, hideIcon }) => {
  const { prospectRegistrationData } = useRegistrationFormContext();
  const navigateToMagicLink = () => {
    window.open(generateBranchLink({ prospectId: prospectRegistrationData.prospectId }), '_blank'); // Opens in a new tab
  };
  return (
    hideIcon ? (
      <StyledButton
        extended
        type="button"
        onClick={() => navigateToMagicLink()}
      >
        {label}
      </StyledButton>
    ) : (
      <StyledButton
        iconProps={{ name: 'arrow-right' }}
        extended
        type="button"
        onClick={() => navigateToMagicLink()}
      >
        {label}
      </StyledButton>
    )
  );
};

MagicLinkBtn.propTypes = {
  hideIcon: PropTypes.bool,
  label: PropTypes.string,
};

MagicLinkBtn.defaultProps = {
  hideIcon: false,
  label: 'Continuar en la app',
};

export default MagicLinkBtn;
